import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootStoreState } from 'src/app/root-store';
import { getAuthorisedNavItems } from 'src/app/root-store/main-app-store/selectors/navigation.selector';
import { NavItem } from 'src/app/models/NavItem'
import { filter, takeUntil } from 'rxjs/operators';
import * as _ from 'underscore';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppRoutes } from 'src/app/shared/endpoints.enum';
import { HeaderService } from 'src/app/services/header.service';

@Component({
  selector: 'kwikspace-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject();

  activeRoute = 'pwa/quotes';
  userType: string;
  userTrial;

  navItems: NavItem[];

  constructor(
    private router: Router,
    private store: Store<RootStoreState.RootState>,
    private headerService: HeaderService
  ) { }

  ngOnInit() {
    this.fetchNavigationItems();
    this.headerService.setAuthorizedNavItems();
  }

  fetchNavigationItems() {
    this.headerService.currentNavItems$.subscribe(navItems => {
      this.navItems = navItems;
    })
  }

  getActiveRoute() {
    return this.activeRoute;
  }

  setActiveTab(tab) {
    this.activeRoute = AppRoutes.PWA + tab;
    this.router.navigate([this.activeRoute]);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
